import { memo } from 'react';

import { BaseExamGridPage } from './BaseExamGridPage';

export const ExamHome = memo(() => {
  return <BaseExamGridPage featureView="Exam" title="Exams" showExamToolbar />;
});

ExamHome.displayName = 'ExamHome';
